export const NAME = 'interview';
